import { Component, input, output } from '@angular/core';
import { MenuDropdownButtonComponent } from '@sandbox-platform/shared-ui';
import { PersonnelDropdownData } from '../desktop-menu.config';
import { NavDropdownComponent } from './nav-dropdown.component';

@Component({
  standalone: true,
  imports: [NavDropdownComponent, MenuDropdownButtonComponent],
  selector: 'lib-personel-dropdown',
  template: `
    <lib-nav-dropdown
      label="Personnel"
      [isOpen]="isOpen()"
      (toggleClicked)="toggleClicked.emit()"
    >
      @if (items().personnel.length) {
      <div class="py-2 border-b border-gray-700">
        <div
          class="px-4 py-2 text-xs font-semibold text-gray-400 uppercase tracking-wider"
        >
          Personnel
        </div>
        @for (item of items().personnel; track item.routerLink) {
        <lib-menu-dropdown-button
          [item]="item"
          (onItemClick)="navigate.emit($event)"
        />
        }
      </div>
      } @if (items().attendance.length) {
      <div class="py-2">
        <div
          class="px-4 py-2 text-xs font-semibold text-gray-400 uppercase tracking-wider"
        >
          Attendance
        </div>
        @for (item of items().attendance; track item.routerLink) {
        <lib-menu-dropdown-button
          [item]="item"
          (onItemClick)="navigate.emit($event)"
        />
        }
      </div>
      }
    </lib-nav-dropdown>
  `,
})
export class PersonelDropdownComponent {
  items = input.required<PersonnelDropdownData>();
  isOpen = input.required<boolean>();

  toggleClicked = output<void>();
  navigate = output<string>();
}
